export default function workIntro () {
	document.querySelectorAll('.work-intro .more').forEach((button) => {
		button.addEventListener('click', () => {
			const section = button.closest('.work-intro');
			const open = section.classList.toggle('is-open');
			const label = button.querySelector('.more-label');
			button.setAttribute('aria-expanded', open ? 'true' : 'false');
			if (label) {
				const text = open ? label.dataset.less : label.dataset.more;
				const line = label.querySelector('.action-line');
				const track = label.querySelector('.action-track');
				if (line) line.textContent = text;
				if (track) track.dataset.text = text;
			}
		});
	});
}
